import React from 'react';
import { PropTypes } from 'prop-types';
// styles
import styled, { css } from 'styled-components';
import SoFormLoadSizeInput from './SoFormLoadSizeInput';
//
import { useTranslation } from 'react-i18next';

const SoFormLoadsSize = ({ className, load }) => {
  const { item_height, item_width, item_length, load_type, pallet_type } = load;
  const { t } = useTranslation('Catalog');

  const isDefaultEU =
    load_type === 'PALLET' &&
    pallet_type === 'EU_PALLET' &&
    item_length === 120 &&
    item_width === 80;

  const isDefaultUS =
    load_type === 'PALLET' &&
    pallet_type === 'US_PALLET' &&
    item_length === 120 &&
    item_width === 100;

  const isDefaultBox =
    load_type === 'PARCEL' &&
    item_length === 60 &&
    item_width === 40 &&
    item_height === 40;

  const isDefaultLength = isDefaultEU || isDefaultUS || isDefaultBox;
  const isDefaultWidth = isDefaultEU || isDefaultUS || isDefaultBox;
  const isDefaultHeight = isDefaultBox;

  const inputs = [
    {
      label: t('configuration.loads.labels.item_length'),
      units: 'cm',
      field: 'item_length',
      isDefault: isDefaultLength,
    },
    {
      label: t('configuration.loads.labels.item_width'),
      units: 'cm',
      field: 'item_width',
      isDefault: isDefaultWidth,
    },
    {
      label: t('configuration.loads.labels.item_height'),
      units: 'cm',
      field: 'item_height',
      isDefault: isDefaultHeight,
    },
    {
      label: t('configuration.loads.labels.total_weight'),
      units: 'kg',
      field: 'total_weight',
      isDefault: false,
    },
  ];
  return (
    <div className={className}>
      {inputs.map((inputData) => (
        <SoFormLoadSizeInput
          inputData={inputData}
          load={load}
          key={inputData.field}
        />
      ))}
    </div>
  );
};

const regularCSS = css`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  height: 48px;
  flex: none;
  /* order: 2; */
  align-self: stretch;
  flex-grow: 1;
`;

SoFormLoadsSize.propTypes = {
  className: PropTypes.string,
};

export default styled(SoFormLoadsSize)`
  ${regularCSS}
`;
